export default __webpack_public_path__ + "static/media/price.257f187a.svg";